/*
 * AppConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

export const DEFAULT_LOCALE = 'en';

export const LOAD_USER_CONFIGS = 'app/App/LOAD_USER_CONFIGS';
export const UPDATE_USER_CONFIGS = 'app/App/UPDATE_USER_CONFIGS';
export const LOAD_USER_CONFIGS_SUCCESS = 'app/App/LOAD_USER_CONFIGS_SUCCESS';
export const UPDATE_USER_CONFIGS_SUCCESS = 'app/App/UPDATE_USER_CONFIGS_SUCCESS';

export const LOAD_INTEGRATIONS_ACTION = 'app/App/LOAD_INTEGRATIONS_ACTION'

export const LOAD_PAYMENTS = 'app/App/LOAD_PAYMENTS'

export const CREATE_INVOICE_SUCCESS_ACTION = 'app/App/CREATE_INVOICE_ACTION'
export const UPDATE_INVOICE_SUCCESS_ACTION = 'app/App/UPDATE_INVOICE_SUCCESS_ACTION';
export const LOAD_UNPAID_INVOICES_ACTION =  'app/App/LOAD_UNPAID_INVOICES_ACTION';

export const DEFAULT_ACTION = 'app/App/DEFAULT_ACTION';
export const AUTH_USER_SET = 'app/App/AUTH_USER_SET';
export const AUTH_USER_SET_SUCCESS = 'app/App/AUTH_USER_SET_SUCCESS';
export const DOCKET_SHOP_VALIDATION_FAILURE = 'app/App/DOCKET_SHOP_VALIDATION_FAILURE';
export const SIGN_OUT = 'app/App/SIGN_OUT';

export const LOAD_USER_PROFILE = 'app/App/LOAD_USER_PROFILE';
export const LOAD_PROFILE_SUCCESS_ACTION = 'app/App/LOAD_PROFILE_SUCCESS_ACTION';

export const LOAD_CUSTOMER_ACTION = 'app/App/LOAD_CUSTOMER_ACTION';
export const LOAD_CUSTOMER_SUCCESS_ACTION = 'app/App/LOAD_CUSTOMER_SUCCESS_ACTION';
export const LOAD_CUSTOMER_FAILURE_ACTION = 'app/App/LOAD_CUSTOMER_FAILURE_ACTION';

export const LOAD_INVOICES_ACTION = 'app/App/LOAD_INVOICES_ACTION';
export const LOAD_INVOICES_SUCCESS_ACTION = 'app/App/LOAD_INVOICES_SUCCESS_ACTION';
export const LOAD_INVOICES_FAILURE_ACTION = 'app/App/LOAD_INVOICES_FAILURE_ACTION';

export const CREATE_CUSTOMER_ACTION = 'app/App/CREATE_CUSTOMER_ACTION';
export const CREATE_CUSTOMER_SUCCESS_ACTION = 'app/App/CREATE_CUSTOMER_SUCCESS_ACTION';
export const CREATE_CUSTOMER_FAILURE_ACTION = 'app/App/CREATE_CUSTOMER_FAILURE_ACTION';

export const UPDATE_CUSTOMER_ACTION = 'app/App/UPDATE_CUSTOMER_ACTION';
export const UPDATE_CUSTOMER_SUCCESS_ACTION = 'app/App/UPDATE_CUSTOMER_SUCCESS_ACTION';
export const UPDATE_CUSTOMER_FAILURE_ACTION = 'app/App/UPDATE_CUSTOMER_FAILURE_ACTION';

export const DELETE_CUSTOMER_ACTION = 'app/App/DELETE_CUSTOMER_ACTION';
export const DELETE_CUSTOMER_SUCCESS_ACTION = 'app/App/DELETE_CUSTOMER_SUCCESS_ACTION';
export const DELETE_CUSTOMER_FAILURE_ACTION = 'app/App/DELETE_CUSTOMER_FAILURE_ACTION';

export const LOAD_CUSTOMERS_ACTION = 'app/App/LOAD_CUSTOMERS_ACTION';
export const LOAD_CUSTOMERS_SUCCESS_ACTION = 'app/App/LOAD_CUSTOMERS_SUCCESS_ACTION';
export const LOAD_CUSTOMERS_FAILURE_ACTION = 'app/App/LOAD_CUSTOMERS_FAILURE_ACTION';

export const LOAD_COMPANY_ACTION = 'app/App/LOAD_COMPANY_ACTION';
export const LOAD_COMPANY_SUCCESS_ACTION = 'app/App/LOAD_COMPANY_SUCCESS_ACTION';
export const LOAD_COMPANY_FAILURE_ACTION = 'app/App/LOAD_COMPANY_FAILURE_ACTION';

export const LOAD_COMPANY_PLAN_ACTION = 'app/App/LOAD_COMPANY_PLAN_ACTION';
export const LOAD_COMPANY_PLAN_SUCCESS_ACTION = 'app/App/LOAD_COMPANY_PLAN_SUCCESS_ACTION';
export const LOAD_COMPANY_PLAN_FAILURE_ACTION = 'app/App/LOAD_COMPANY_PLAN_FAILURE_ACTION';

export const CREATE_COMPANY_ACTION = 'app/App/CREATE_COMPANY_ACTION';
export const CREATE_COMPANY_SUCCESS_ACTION = 'app/App/CREATE_COMPANY_SUCCESS_ACTION';
export const CREATE_COMPANY_FAILURE_ACTION = 'app/App/CREATE_COMPANY_FAILURE_ACTION';

export const UPDATE_COMPANY_ACTION = 'app/App/UPDATE_COMPANY_ACTION';
export const UPDATE_COMPANY_SUCCESS_ACTION = 'app/App/UPDATE_COMPANY_SUCCESS_ACTION';
export const UPDATE_COMPANY_FAILURE_ACTION = 'app/App/UPDATE_COMPANY_FAILURE_ACTION';

export const UPDATE_PLAN_ACTION = 'app/App/UPDATE_PLAN_ACTION';
export const UPDATE_PLAN_SUCCESS_ACTION = 'app/App/UPDATE_PLAN_SUCCESS_ACTION';
export const UPDATE_PLAN_FAILURE_ACTION = 'app/App/UPDATE_PLAN_FAILURE_ACTION';

export const SUBSCRIBE_ACTION = 'app/App/SUBSCRIBE_ACTION'
export const SUBSCRIBE_SUCCESS_ACTION = 'app/App/SUBSCRIBE_SUCCESS_ACTION';
export const SUBSCRIBE_FAILURE_ACTION = 'app/App/SUBSCRIBE_FAILURE_ACTION';

export const STRIPE_CONNECT_ACTION = 'app/App/STRIPE_CONNECT_ACTION'
export const STRIPE_CONNECT_SUCCESS_ACTION = 'app/App/STRIPE_CONNECT_SUCCESS_ACTION';
export const STRIPE_CONNECT_FAILURE_ACTION = 'app/App/STRIPE_CONNECT_FAILURE_ACTION';

export const LOAD_CC_GATEWAY_ACTION = 'app/App/LOAD_CC_GATEWAY_ACTION'
export const LOAD_CC_GATEWAY_SUCCESS_ACTION = 'app/App/LOAD_CC_GATEWAY_SUCCESS_ACTION';
export const LOAD_CC_GATEWAY_FAILURE_ACTION = 'app/App/LOAD_CC_GATEWAY_FAILURE_ACTION';

export const SYNC_PRODUCTS = 'app/App/SYNC_PRODUCTS';
export const FETCH_PRODUCTS = 'app/App/FETCH_PRODUCTS';
export const FETCH_PRODUCTS_SUCCESS = 'app/App/FETCH_PRODUCTS_SUCCESS';
export const FETCH_PRODUCTS_FAILURE = 'app/App/FETCH_PRODUCTS_FAILURE';

export const SAVE_PRODUCT = 'app/App/SAVE_PRODUCT';
export const SAVE_PRODUCT_SUCCESS = 'app/App/SAVE_PRODUCT_SUCCESS';
export const SAVE_PRODUCT_FAILURE = 'app/App/SAVE_PRODUCT_FAILURE';

export const DELETE_PRODUCT = 'app/App/DELETE_PRODUCT';
export const DELETE_PRODUCT_SUCCESS = 'app/App/DELETE_PRODUCT_SUCCESS';
export const DELETE_PRODUCT_FAILURE = 'app/App/DELETE_PRODUCT_FAILURE';

export const SYNC_VARIANTS = 'app/App/SYNC_VARIANTS';
export const FETCH_VARIANTS = 'app/App/FETCH_VARIANTS';
export const FETCH_VARIANTS_FAILURE = 'app/App/FETCH_VARIANTS_FAILURE';
export const FETCH_VARIANTS_SUCCESS = 'app/App/FETCH_VARIANTS_SUCCESS';

export const SAVE_VARIANT = 'app/App/SAVE_VARIANT';
export const SAVE_VARIANT_SUCCESS = 'app/App/SAVE_VARIANT_SUCCESS';
export const SAVE_VARIANT_FAILURE = 'app/App/SAVE_VARIANT_FAILURE';

export const DELETE_VARIANT = 'app/App/DELETE_VARIANT';
export const DELETE_VARIANT_SUCCESS = 'app/App/DELETE_VARIANT_SUCCESS';
export const DELETE_VARIANT_FAILURE = 'app/App/DELETE_VARIANT_FAILURE';

export const SYNC_DISCOUNTS = 'app/App/SYNC_DISCOUNTS';
export const FETCH_DISCOUNTS = 'app/App/FETCH_DISCOUNTS';
export const FETCH_DISCOUNTS_SUCCESS = 'app/App/FETCH_DISCOUNTS_SUCCESS';
export const FETCH_DISCOUNTS_FAILURE = 'app/App/FETCH_DISCOUNTS_FAILURE';
export const SAVE_DISCOUNT = 'app/App/SAVE_DISCOUNT';
export const SAVE_DISCOUNT_SUCCESS = 'app/App/SAVE_DISCOUNT_SUCCESS';
export const SAVE_DISCOUNT_FAILURE = 'app/App/SAVE_DISCOUNT_FAILURE';
export const DELETE_DISCOUNT = 'app/App/DELETE_DISCOUNT';
export const DELETE_DISCOUNT_SUCCESS = 'app/App/DELETE_DISCOUNT_SUCCESS';
export const DELETE_DISCOUNT_FAILURE = 'app/App/DELETE_DISCOUNT_FAILURE';

export const SAVE_WORKFLOW = 'app/App/SAVE_WORKFLOW';
export const SAVE_WORKFLOW_SUCCESS = 'app/App/SAVE_WORKFLOW_SUCCESS';
export const SAVE_WORKFLOW_FAILURE = 'app/App/SAVE_WORKFLOW_FAILURE';

export const DELETE_WORKFLOW = 'app/App/DELETE_WORKFLOW';
export const DELETE_WORKFLOW_SUCCESS = 'app/App/DELETE_WORKFLOW_SUCCESS';
export const DELETE_WORKFLOW_FAILURE = 'app/App/DELETE_WORKFLOW_FAILURE';

export const SYNC_WORKFLOWS = 'app/App/SYNC_WORKFLOWS';
export const FETCH_WORKFLOWS = 'app/App/FETCH_WORKFLOWS';
export const FETCH_WORKFLOWS_SUCCESS = 'app/App/FETCH_WORKFLOWS_SUCCESS';
export const FETCH_WORKFLOWS_FAILURE = 'app/App/FETCH_WORKFLOWS_FAILURE';

export const SYNC_CONNECTED_ACCOUNTS = 'app/App/SYNC_CONNECTED_ACCOUNTS';

export const FETCH_CONNECTED_ACCOUNTS = 'app/App/FETCH_CONNECTED_ACCOUNTS';
export const FETCH_CONNECTED_ACCOUNTS_SUCCESS = 'app/App/FETCH_CONNECTED_ACCOUNTS_SUCCESS';
export const FETCH_CONNECTED_ACCOUNTS_FAILURE = 'app/App/FETCH_CONNECTED_ACCOUNTS_FAILURE';

export const FETCH_CONNECTED_COMPANIES = 'app/App/FETCH_CONNECTED_COMPANIES';
export const FETCH_CONNECTED_COMPANIES_SUCCESS = 'app/App/FETCH_CONNECTED_COMPANIES_SUCCESS';
export const FETCH_CONNECTED_COMPANIES_FAILURE = 'app/App/FETCH_CONNECTED_COMPANIES_FAILURE';

export const SAVE_CONNECTED_ACCOUNT = 'app/App/SAVE_CONNECTED_ACCOUNT';
export const SAVE_CONNECTED_ACCOUNT_SUCCESS = 'app/App/SAVE_CONNECTED_ACCOUNT_SUCCESS';
export const SAVE_CONNECTED_ACCOUNT_FAILURE = 'app/App/SAVE_CONNECTED_ACCOUNT_FAILURE';

export const REMOVE_CONNECTED_ACCOUNT = 'app/App/REMOVE_CONNECTED_ACCOUNT';
export const REMOVE_CONNECTED_ACCOUNT_SUCCESS = 'app/App/REMOVE_CONNECTED_ACCOUNT_SUCCESS';
export const REMOVE_CONNECTED_ACCOUNT_FAILURE = 'app/App/REMOVE_CONNECTED_ACCOUNT_FAILURE';

export const LOAD_PERMISSIONS_ACTION = 'app/App/LOAD_PERMISSIONS_ACTION'
export const LOAD_PERMISSIONS_SUCCESS_ACTION = 'app/App/LOAD_PERMISSIONS_SUCCESS_ACTION';
export const LOAD_PERMISSIONS_FAILURE_ACTION = 'app/App/LOAD_PERMISSIONS_FAILURE_ACTION';

export const CREATE_DOCUMENT_ACTION = 'app/App/CREATE_DOCUMENT_ACTION';
export const CREATE_DOCUMENT_SUCCESS_ACTION = 'app/App/CREATE_DOCUMENT_SUCCESS_ACTION';
export const CREATE_DOCUMENT_FAILURE_ACTION = 'app/App/CREATE_DOCUMENT_FAILURE_ACTION';

export const UPDATE_DOCUMENT_ACTION = 'app/App/UPDATE_DOCUMENT_ACTION';
export const UPDATE_DOCUMENT_SUCCESS_ACTION = 'app/App/UPDATE_DOCUMENT_SUCCESS_ACTION';
export const UPDATE_DOCUMENT_FAILURE_ACTION = 'app/App/UPDATE_DOCUMENT_FAILURE_ACTION';

export const DELETE_DOCUMENT_ACTION = 'app/App/DELETE_DOCUMENT_ACTION';
export const DELETE_DOCUMENT_SUCCESS_ACTION = 'app/App/DELETE_DOCUMENT_SUCCESS_ACTION';
export const DELETE_DOCUMENT_FAILURE_ACTION = 'app/App/DELETE_DOCUMENT_FAILURE_ACTION';

export const LOAD_DOCUMENTS_ACTION = 'app/App/LOAD_DOCUMENTS_ACTION';

export const CREATE_DOCUMENT_INSTANCE_ACTION = 'app/App/CREATE_DOCUMENT_INSTANCE_ACTION';
export const CREATE_DOCUMENT_INSTANCE_SUCCESS_ACTION = 'app/App/CREATE_DOCUMENT_INSTANCE_SUCCESS_ACTION';
export const CREATE_DOCUMENT_INSTANCE_FAILURE_ACTION = 'app/App/CREATE_DOCUMENT_INSTANCE_FAILURE_ACTION';

export const UPDATE_DOCUMENT_INSTANCE_ACTION = 'app/App/UPDATE_DOCUMENT_INSTANCE_ACTION';
export const UPDATE_DOCUMENT_INSTANCE_SUCCESS_ACTION = 'app/App/UPDATE_DOCUMENT_INSTANCE_SUCCESS_ACTION';
export const UPDATE_DOCUMENT_INSTANCE_FAILURE_ACTION = 'app/App/UPDATE_DOCUMENT_INSTANCE_FAILURE_ACTION';

export const DELETE_DOCUMENT_INSTANCE_ACTION = 'app/App/DELETE_DOCUMENT_INSTANCE_ACTION';
export const DELETE_DOCUMENT_INSTANCE_SUCCESS_ACTION = 'app/App/DELETE_DOCUMENT_INSTANCE_SUCCESS_ACTION';
export const DELETE_DOCUMENT_INSTANCE_FAILURE_ACTION = 'app/App/DELETE_DOCUMENT_INSTANCE_FAILURE_ACTION';

export const SHARE_DOCUMENT_INSTANCE_ACTION = 'app/App/SHARE_DOCUMENT_INSTANCE_ACTION';
export const LOAD_DOCUMENT_INSTANCES_ACTION = 'app/App/LOAD_DOCUMENT_INSTANCES_ACTION';

export const LOAD_COMPANY_MEMBERS_ACTION = 'app/App/LOAD_COMPANY_MEMBERS_ACTION';
export const LOAD_COMPANY_MEMBERS_SUCCESS_ACTION = 'app/App/LOAD_COMPANY_MEMBERS_SUCCESS_ACTION';

export const QB_SYNC_INVOICES_ACTION = 'app/App/QB_SYNC_INVOICES_ACTION';
export const QB_SYNC_FINSISHED_ACTION = 'app/App/QB_SYNC_FINSISHED_ACTION';
export const QB_SYNC_CUSTOMERS_ACTION = 'app/App/QB_SYNC_CUSTOMERS_ACTION';

export const UPDATE_USER_ACTION = 'app/App/UPDATE_USER_ACTION';

export const SAVE_CART_CONFIGURATION = 'app/App/SAVE_CART_CONFIGURATION';
export const SAVE_CART_CONFIGURATION_SUCCESS = 'app/App/SAVE_CART_CONFIGURATION_SUCCESS';
export const SAVE_CART_CONFIGURATION_FAILURE = 'app/App/SAVE_CART_CONFIGURATION_FAILURE';

export const DELETE_CART_CONFIGURATION = 'app/App/DELETE_CART_CONFIGURATION';
export const DELETE_CART_CONFIGURATION_SUCCESS = 'app/App/DELETE_CART_CONFIGURATION_SUCCESS';
export const DELETE_CART_CONFIGURATION_FAILURE = 'app/App/DELETE_CART_CONFIGURATION_FAILURE';

export const SYNC_CART_CONFIGURATIONS = 'app/App/SYNC_CART_CONFIGURATIONS';
export const FETCH_CART_CONFIGURATIONS = 'app/App/FETCH_CART_CONFIGURATIONS';
export const FETCH_CART_CONFIGURATIONS_SUCCESS = 'app/App/FETCH_CART_CONFIGURATIONS_SUCCESS';
export const FETCH_CART_CONFIGURATIONS_FAILURE = 'app/App/FETCH_CART_CONFIGURATIONS_FAILURE';

export const SAVE_EMBED_CONFIGURATION = 'app/App/SAVE_EMBED_CONFIGURATION';
export const SAVE_EMBED_CONFIGURATION_SUCCESS = 'app/App/SAVE_EMBED_CONFIGURATION_SUCCESS';
export const SAVE_EMBED_CONFIGURATION_FAILURE = 'app/App/SAVE_EMBED_CONFIGURATION_FAILURE';

export const DELETE_EMBED_CONFIGURATION = 'app/App/DELETE_EMBED_CONFIGURATION';
export const DELETE_EMBED_CONFIGURATION_SUCCESS = 'app/App/DELETE_EMBED_CONFIGURATION_SUCCESS';
export const DELETE_EMBED_CONFIGURATION_FAILURE = 'app/App/DELETE_EMBED_CONFIGURATION_FAILURE';

export const SYNC_EMBED_CONFIGURATIONS = 'app/App/SYNC_EMBED_CONFIGURATIONS';
export const FETCH_EMBED_CONFIGURATIONS = 'app/App/FETCH_EMBED_CONFIGURATIONS';
export const FETCH_EMBED_CONFIGURATIONS_SUCCESS = 'app/App/FETCH_EMBED_CONFIGURATIONS_SUCCESS';
export const FETCH_EMBED_CONFIGURATIONS_FAILURE = 'app/App/FETCH_EMBED_CONFIGURATIONS_FAILURE';

export const FETCH_API_KEYS = 'app/App/FETCH_API_KEYS';
export const FETCH_API_KEYS_SUCCESS = 'app/App/FETCH_API_KEYS_SUCCESS';

export const FEATURE_CONNECTED_ACCOUNTS = 'connected_accounts';
export const FEATURE_ROUTE_BASED_DISTANCE_CALCULATION = 'route_based_distance_calculation';
export const FEATURE_WORKFLOWS_UNLIMITED = 'workflows_unlimited';
export const FEATURE_PRODUCT_SETS_UNLIMITED = 'product_sets_unlimited';
export const FEATURE_VARIANTS_UNLIMITED = 'variants_unlimited';
export const FEATURE_WHITE_LABEL_SHOPPING_CART = 'whitelabel_shopping_cart';
export const FEATURE_PREMIUM_THEMING = 'premium_theming';
export const FEATURE_SESSION_INSIGHTS = 'session_insights';
export const FEATURE_URL_REDIRECT_LANDING_PAGE = 'url_redirect_landing_page';
export const FEATURE_URL_REDIRECT_ORDER_SUBMISSION = 'url_redirect_order_submission';
export const FEATURE_URL_REDIRECT_OUT_OF_SERVICE = 'url_redirect_out_of_service';
export const FEATURE_GOOGLE_ANALYTICS_EVENTS = 'google_analytics_events';
export const FEATURE_DISCOUNT_CODES = 'discount_codes';
export const FEATURE_QUESTION_REDIRECTS = 'url_redirect_questions';
export const FEATURE_ABANDONED_CART = 'abandoned_cart';
export const SET_MAX_DAILY_BOOKABLE_TASKS = 'set_max_daily_bookable_tasks';

export const ADD_LOG = 'app/App/ADD_LOG';

export const LOAD_AD_HOC_ENTITY = 'app/App/LOAD_AD_HOC_ENTITY';
export const LOAD_AD_HOC_ENTITY_SUCCESS = 'app/App/LOAD_AD_HOC_ENTITY_SUCCESS';
export const LOAD_AD_HOC_INVOICE = 'app/App/LOAD_AD_HOC_INVOICE';
export const LOAD_MESSAGES = 'app/App/LOAD_MESSAGES';
export const LOAD_LOGS = 'app/App/LOAD_LOGS';

export const LOAD_UNASSIGNED_INVOICES_SUCCESS_ACTION = 'app/App/LOAD_UNASSIGNED_INVOICES_SUCCESS_ACTION';

export const LOAD_TIME_ENTRIES_ACTION = 'app/App/LOAD_TIME_ENTRIES_ACTION';
export const LOAD_TIME_ENTRIES_SUCCESS_ACTION = 'app/App/LOAD_TIME_ENTRIES_SUCCESS_ACTION';
export const LOAD_TIME_ENTRIES_FAILURE_ACTION = 'app/App/LOAD_TIME_ENTRIES_FAILURE_ACTION';

export const UPDATE_PRICING_MATRIX = 'app/App/UPDATE_PRICING_MATRIX';
export const UPDATE_PRICING_MATRIX_SUCCESS = 'app/App/UPDATE_PRICING_MATRIX_SUCCESS';
export const UPDATE_PRICING_MATRIX_FAILURE = 'app/App/UPDATE_PRICING_MATRIX_FAILURE';

export const LOAD_REFERRALS = 'app/App/LOAD_REFERRALS';
export const LOAD_REFERRALS_SUCCESS = 'app/App/LOAD_REFERRALS_SUCCESS';
export const LOAD_REFERRALS_FAILURE = 'app/App/LOAD_REFERRALS_FAILURE';

export const SYNC_INVOICE = 'app/App/SYNC_INVOICE';
export const SYNC_INVOICE_SUCCESS = 'app/App/SYNC_INVOICE_SUCCESS';
export const SYNC_INVOICE_FAILURE = 'app/App/SYNC_INVOICE_FAILURE';
